import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-55054904")


    
export default _defineComponent({
  props: {
        active: {type: Boolean, default: true},
        label: {type: String, default: null},
        count: {type: Number, default: null}
    },
  setup(__props) {

const props = __props
    /* eslint-disable no-unused-vars */
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["feature-list-item", {active: __props.active}]
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _createTextVNode(" " + _toDisplayString(__props.count) + " " + _toDisplayString(__props.label), 1)
  ], 2))
}
}

})